<template>
  <div>
    <FamilyOverviewCard class="mb-4" />
    <BackgroundOverviewCard class="mb-4" />
    <HistoryOverviewCard class="mb-4" />
    <PersonalOverviewCard
      :item="peParty.overview"
      class="mb-4"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import BackgroundOverviewCard from './SectionCards/OverviewCards/BackgroundOverviewCard.vue'
import FamilyOverviewCard from './SectionCards/OverviewCards/FamilyOverviewCard.vue'
import HistoryOverviewCard from './SectionCards/OverviewCards/HistoryOverviewCard.vue'
import { PARTY_NAMESPACE } from '@/store/party'
import PersonalOverviewCard from './SectionCards/OverviewCards/PersonalOverviewCard.vue'
import { alertHandler } from '@/alertHandler'

export default {
  name: 'PEOverview',

  components: {
    BackgroundOverviewCard,
    FamilyOverviewCard,
    HistoryOverviewCard,
    PersonalOverviewCard,
  },

  beforeRouteLeave (_, __, next) {
    if (this.peAnyUnlockedSections) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.peLockPartySections()
        next()
      } else next(false)
    } else {
      this.peLockPartySections()
      next()
    }
  },

  setup () {
    return { ...alertHandler() }
  },

  computed: {
    ...mapGetters(PARTY_NAMESPACE, [
      'peAnyUnlockedSections',
      'peParty',
    ]),
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peLockPartySections',
    ]),
  },
}
</script>
